import styled from '@emotion/styled'
import { Link } from 'gatsby'
import React from 'react'
import BreakPoints from '../../styles/breakPoints'
import CommonBtn from '../atoms/commonBtn'
import LogoSvg from '../atoms/logoSvg'
import SearchInput from '../atoms/searchInput'
import useRouteParam from '../../hooks/useRouteParam'
import HelpSpNav from '../molecules/help/helpSpNav'

const Wrapper = styled.header`
  .header {
    display: flex;
    flex-wrap: wrap;
    padding: 10px 0 0 10px;
    height: auto;
    align-items: flex-start;
    position: relative;
    background: #fff;

    a {
      color: #00b5a6;
    }

    .logo-link {
      height: 64px;
      display: flex;
      align-items: center;
      margin: 0 auto 0 0;

      .logo {
        margin: 0 5px 0 0;
        padding: 0;
        width: 170px;
      }

      .txt {
        font-size: 0.6em;
        line-height: 1em;
      }

      text-decoration: none;

      &:hover {
        text-decoration: none;
      }
    }

    .right-btn-area {
      display: flex;
      width: 320px;
      justify-content: space-between;
      margin: 0 0 0 auto;
      align-items: center;
      position: relative;

      button {
        padding: 0 15px;
        min-width: 30px;
      }

      a {
        display: block;
        margin: 0 0 0 10px;
      }
    }
  }

  .top-search {
    width: 100%;
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    overflow: hidden;
    padding: 0;
    margin-bottom: 30px;

    .inner {
      width: calc(100% + 400px);
      margin: 0 -200px;
      padding: 0 200px;
      display: flex;
      flex-direction: column;
      flex-wrap: wrap;
      align-items: center;
      justify-content: center;
      background: #fff;
      height: 260px;
      border-bottom-right-radius: 2000px 300px;
      border-bottom-left-radius: 2000px 300px;

      .search-wrap {
        margin: 20px auto 30px auto;
        width: 480px;
        justify-content: center;
        align-items: center;
      }

      .logo {
        display: flex;
        height: 50px;
        justify-content: center;
        margin-bottom: 20px;

        .txt {
          font-weight: bold;
          color: #00b5a6;
          font-size: 28px;
          margin: auto 0 auto 10px;
        }
      }

      .search-txt {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        text-align: center;
        height: 72px;
      }
    }
  }

  @media screen and (max-width: 870px) {
    .search-wrap.search-input-wrap {
      position: absolute;
      bottom: 0;
    }
  }

  ${BreakPoints.large} {
    .header {
      position: fixed;
      z-index: 100;
      top: 0;
      height: 45px;
      width: 100vw;
      background: #ffffff;
      box-shadow: 0 3px 3px rgba(0, 0, 0, 0.1);
      padding: 3px 10px 0;

      .logo-link {
        height: 40px;

        .logo {
          width: 140px;
        }

        .txt {
          color: #243750;
        }
      }

      .right-btn-area {
        display: none;
      }
    }

    .top-search {
      padding-top: 45px;

      .inner {
        height: 200px;

        .logo {
          margin: 0;
        }

        .search-wrap {
          max-width: 400px;
          width: 90vw;
          left: unset;
          margin: 0;
          bottom: 50px;
          font-size: 15px !important;
        }

        .logo {
          display: none;
        }

        .search-txt {
          position: absolute;
          top: 60px;
        }
      }
    }
  }
`

/**
 * ヘッダー[TOP]
 * @constructor
 */
const HeaderTop = () => {
  const routeParam = useRouteParam('/support')
  const routeParam2 = useRouteParam('/')
  const routeParam3 = useRouteParam('https://app.kintaicloud.jp')
  return (
    <Wrapper>
      <div className="header">
        <h1>
          <Link to={useRouteParam('/help/')} className="logo-link">
            <LogoSvg />
            <span className="txt">ヘルプ</span>
          </Link>
        </h1>
        <HelpSpNav />
        <div className="right-btn-area">
          <a href={routeParam} target="_blank" rel="noreferrer">
            お問い合わせ
          </a>
          <a href={routeParam2} target="_blank" rel="noreferrer">
            製品サイト
          </a>
          <CommonBtn size="large" onClick={() => window.open(routeParam3)}>
            ログイン
          </CommonBtn>
        </div>
      </div>
      <div className="top-search">
        <div className="inner">
          <div className="logo">
            <LogoSvg />
            <span className="txt">ヘルプ</span>
          </div>
          <div className="search-txt">
            <h1 className="search-h1">お困りですか？</h1>
            <p>ヘルプをキーワードで検索することが可能です。</p>
          </div>
          <SearchInput className="search-wrap" />
        </div>
      </div>
    </Wrapper>
  )
}

export default HeaderTop
